/* eslint-disable import/no-restricted-paths */
import { IAPIParameters } from '@cian/mf-registry-legacy/browser';

import { ensureHeaderMicrofrontend } from '../../microfrontend';
import { IOpenAuthModalParameters } from '../../../../../node/services/microfrontends/types';

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call('/v2/open-auth-modal/', parameters as IAPIParameters);
}
